(function($) {
    // Sticky Header
    $(window).on("scroll load", function () {
        if ($(window).scrollTop() >= 20) {
            $('header').addClass('scrolled');
        } else {
            $('header').removeClass('scrolled');
        }
    });
})( jQuery );